import { TRACTION, AS_OF } from "./data";
import { Reveal, SectionHead } from "./shared";

const TONES = {
  live: "border-emerald-500/30 bg-emerald-500/10 text-emerald-400",
  active: "border-[#FF5500]/40 bg-[#FF5500]/10 text-[#FF7A33]",
  zero: "border-[#FF5500]/40 bg-[#FF5500]/10 text-[#FF7A33]",
  pending: "border-amber-500/30 bg-amber-500/10 text-amber-400",
  declined: "border-slate-600 bg-slate-500/10 text-slate-400",
};

export default function Traction() {
  return (
    <section id="traction" data-testid="traction-section" className="border-y border-slate-800 bg-[#0C111C]">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <SectionHead
          index="02"
          overline="Traction & Readiness"
          title={`The honest board — ${AS_OF}`}
          note="Pre-revenue and printed that way. Where the number is zero, the zero is printed."
        />

        <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-slate-800 bg-slate-800 sm:grid-cols-2 lg:grid-cols-4">
          {TRACTION.map((t, i) => (
            <Reveal key={t.testid} delay={(i % 4) * 0.06} y={20} className="h-full">
              <div data-testid={t.testid} className="flex h-full flex-col bg-[#0D1320] p-6">
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">{t.label}</p>
                  <span
                    className={`whitespace-nowrap rounded-full border px-2.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-widest ${TONES[t.tone]}`}
                  >
                    {t.status}
                  </span>
                </div>
                <p className="font-display mt-4 text-2xl font-semibold uppercase tracking-tight text-slate-100">
                  {t.value}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{t.detail}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-10">
          <p data-testid="traction-founder-note" className="max-w-3xl border-l-2 border-[#FF5500] pl-5 text-base leading-relaxed text-slate-300">
            We would rather you pass on real numbers than wire money against invented ones. If
            founding pilots on active jobsites sound like evidence worth funding, that is exactly
            what this bridge buys.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
